/**
 * Add POS to a model
 */

import SVG from 'svg.js';
import Application from '../application';
import { POS } from '@/store/modules/pos';

export interface PosRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  app: Application;
  shape: SVG.Shape;
}

export const PosMixin = <T extends { new (...args: any[]): PosRequirements }>(base: T) => {
  return class PosMixin extends base {
    isConflicted = false;
    prevStrokeColor: string | null = null;

    get pointOfSale() {
      return this.attributes.posId || null;
    }

    set pointOfSale(pos) {
      if (!pos || this.attributes.posId === pos.id) {
        delete this.attributes.posId;
      } else {
        this.attributes.posId = pos.id;
      }
      if (this.app.isShowPosColor() && this.attributes.posId !== undefined) {
        this.applyPosColor(pos.color);
      } else {
        this.removePosColor();
      }
    }

    assignPos(pos: POS) {
      this.pointOfSale = pos;
    }

    unassignPos() {
      this.pointOfSale = null;
    }

    applyPosColor(color: string | null) {
      if (this.app.isShowConflicts() && this.isConflicted) {
        this.prevStrokeColor = this.app.getPosColor(this.pointOfSale);
        this.shape.style('stroke', '#aa0000');
      } else {
        if (this.isConflicted && !this.app.isShowConflicts()) {
          this.prevStrokeColor = '#aa0000';
        } else {
          this.prevStrokeColor = null;
        }
        if (!color) {
          color = this.app.getPosColor(this.pointOfSale);
        }
        if (color) {
          this.shape.style('stroke', color);
          this.shape.style('stroke-width', 1.5);
        }
      }
    }

    removePosColor() {
      if (this.app.isShowConflicts() && this.isConflicted) {
        this.prevStrokeColor = null;
        this.shape.style('stroke', '#aa0000');
      } else {
        this.prevStrokeColor = '#aa0000';
        this.shape.style('stroke', null);
        this.shape.style('stroke-width', 1);
      }
    }
  };
};
